class BoxtCartDropdown extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Listen for cart:updated (standard for Dawn/Shopify Ajax API wrappers)
    document.addEventListener('cart:updated', () => this.updateCart());

    // When add-to-cart is from product tables (box/case), open dropdown for feedback
    document.addEventListener('cart:openDropdown', () => {
      this.updateCart().then(() => this.openDropdown());
    });

    // If using PUB_SUB
    if (window.pubsub) {
      window.pubsub.subscribe('cart-update', () => this.updateCart());
    }
  }

  updateCart() {
    // Fetch the header section to get updated cart icon, badge, subtotal, and dropdown HTML
    return fetch(`${window.Shopify.routes.root}?section_id=header`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // 1. Update Cart Icon (Badge & Subtotal)
        const sourceCartIcon = html.getElementById('cart-icon-bubble');
        const targetCartIcon = document.getElementById('cart-icon-bubble');

        if (sourceCartIcon && targetCartIcon) {
          targetCartIcon.innerHTML = sourceCartIcon.innerHTML;
        }

        // 2. Update Cart Dropdown Content
        const sourceDropdown = html.querySelector('.boxt-cart-dropdown');
        const targetDropdown = document.querySelector('.boxt-cart-dropdown');

        if (sourceDropdown && targetDropdown) {
          targetDropdown.innerHTML = sourceDropdown.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  openDropdown() {
    this.classList.add('boxt-cart--dropdown-visible');
    const closeDelay = window.matchMedia('(max-width: 749px)').matches ? 3000 : 5000;
    this._dropdownCloseTimeout = window.setTimeout(() => {
      this.closeDropdown();
    }, closeDelay);

    const closeOnClickOutside = (e) => {
      if (this.contains(e.target)) return;
      document.removeEventListener('click', closeOnClickOutside);
      this.closeDropdown();
    };
    document.addEventListener('click', closeOnClickOutside);
    this._closeOnClickOutside = closeOnClickOutside;
  }

  closeDropdown() {
    if (this._dropdownCloseTimeout) {
      window.clearTimeout(this._dropdownCloseTimeout);
      this._dropdownCloseTimeout = null;
    }
    if (this._closeOnClickOutside) {
      document.removeEventListener('click', this._closeOnClickOutside);
      this._closeOnClickOutside = null;
    }
    this.classList.remove('boxt-cart--dropdown-visible');
  }
}

customElements.define('boxt-cart-dropdown', BoxtCartDropdown);

// Also hook into global fetch to catch cart/add.js if events aren't firing reliably
// This is a safety net.
(function() {
    const originalFetch = window.fetch;
    window.fetch = function() {
        return originalFetch.apply(this, arguments).then((response) => {
            if (response.url.includes('/cart/add') || response.url.includes('/cart/update') || response.url.includes('/cart/change')) {
                 // Dispatch cart:updated if not already dispatched by theme
                 // Or just manually trigger the update on our component
                 const dropdown = document.querySelector('boxt-cart-dropdown');
                 if (dropdown) dropdown.updateCart();
            }
            return response;
        });
    };
})();
